{
  "accessDenied": "拒绝访问",
  "action": "操作",
  "active": "已激活",
  "address": "地址",
  "amount": "金额",
  "appName": "Exalt 交易所",
  "apply": "申请",
  "approved": "已批准",
  "available": "可用",
  "back": "返回",
  "balance": "余额",
  "cancel": "取消",
  "cancelled": "已取消",
  "cardProviderRequired": "需要提供商集成",
  "cardProviderRequiredDescription": "EXALT 卡尚未可用。必须先连接真实的发卡提供商才能使用此功能。",
  "close": "关闭",
  "closed": "已关闭",
  "coin": "币种",
  "comingSoon": "敬请期待",
  "completed": "已完成",
  "confirm": "确认",
  "continue": "继续",
  "copy": "复制",
  "copyFailed": "复制失败。",
  "copyright": "版权所有。",
  "country": "国家",
  "currency": "货币",
  "date": "日期",
  "delete": "删除",
  "description": "描述",
  "details": "详情",
  "disabled": "已禁用",
  "download": "下载",
  "edit": "编辑",
  "email": "邮箱",
  "enabled": "已启用",
  "error": "错误",
  "exaltCard": "EXALT 卡",
  "exchange": "交易所",
  "failed": "失败",
  "fast": "快速",
  "fillAllRequiredFields": "请填写所有必填字段。",
  "gated": "受限",
  "global": "全球",
  "inactive": "未激活",
  "information": "信息",
  "invalidRequest": "无效请求。",
  "language": "语言",
  "languagePreferences": "语言偏好",
  "loading": "加载中...",
  "locked": "已锁定",
  "lockedBalance": "锁定余额",
  "name": "姓名",
  "network": "网络",
  "networkError": "网络错误。",
  "next": "下一步",
  "no": "否",
  "noAssetsFound": "未找到资产。",
  "noDataFound": "未找到数据。",
  "noResultsFound": "未找到结果。",
  "noRewardsYet": "暂无奖励。",
  "noRewardsYetDescription": "真实的推荐和质押奖励将在您获得后显示在此处。",
  "notAvailable": "暂不可用",
  "notVerified": "未验证",
  "note": "备注",
  "notificationCenter": "通知",
  "open": "打开",
  "openStatus": "开放",
  "pending": "待处理",
  "permissionRequired": "您没有执行此操作的权限。",
  "phone": "电话",
  "pleaseLoginFirst": "请先登录。",
  "price": "价格",
  "processing": "处理中...",
  "reference": "参考号",
  "referralProgram": "推荐计划",
  "refresh": "刷新",
  "refreshing": "刷新中...",
  "rejected": "已拒绝",
  "remove": "移除",
  "requestFailed": "请求失败。",
  "rewardsCenter": "奖励中心",
  "rewardsUnavailable": "目前无法加载您的奖励。",
  "role": "角色",
  "save": "保存",
  "saving": "保存中...",
  "search": "搜索",
  "searchAssets": "搜索资产",
  "secure": "安全",
  "sending": "发送中...",
  "serverError": "服务器错误。",
  "servicesHub": "服务",
  "sessionExpired": "会话已过期，请重新登录。",
  "spot": "现货",
  "status": "状态",
  "submit": "提交",
  "submitting": "提交中...",
  "success": "成功",
  "system": "系统",
  "time": "时间",
  "token": "代币",
  "total": "总计",
  "transactionHash": "交易哈希",
  "type": "类型",
  "uid": "UID",
  "unauthorized": "未授权",
  "unlocked": "已解锁",
  "update": "更新",
  "upload": "上传",
  "user": "用户",
  "userId": "用户ID",
  "value": "价值",
  "verified": "已验证",
  "view": "查看",
  "viewAllNotifications": "查看所有通知",
  "wallet": "钱包",
  "walletAddress": "钱包地址",
  "warning": "警告",
  "yes": "是"
}